import React from 'react';
import {  Segment } from 'semantic-ui-react';
import axios from 'axios';
import { Grid ,Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import 'antd/dist/antd.css';
import '../sidemenu.css';
import '../report.css';
import {reactLocalStorage} from 'reactjs-localstorage';
import "react-notifications-component/dist/theme.css";
import 'semantic-ui-css/semantic.min.css';
import '@brainhubeu/react-carousel/lib/style.css';
import i18n from '../i18n';
import {connect} from 'react-redux';
import MenuSideWebCMS from './side_menu_web_cms.js';
import { List } from 'semantic-ui-react'
import { API_BASE_URL } from "../utils/endpoints";

  class Adds extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
   
          persons: [],

        }
    
      }
    getUsers()
{

    var token=reactLocalStorage.get('accessToken');
     var ip=API_BASE_URL;
     var s2 = "localhost:3000";
     var apiBaseUrl;
     if(ip.includes(s2))
     {
      apiBaseUrl =API_BASE_URL + "/core/user/rest/advertisments/getAllAdv";
     }
     else
     {
      apiBaseUrl = API_BASE_URL+"/core/user/rest/advertisments/getAllAdv";
     }
     var headers = {'Content-Type': 'application/json', 'token' :token }
     axios.get(apiBaseUrl,{headers: headers})
         .then(res => {
           const persons = res.data.result.advertisments;
           if(persons != undefined)
           {
             this.setState({ persons });

           }
           
         })
}
componentDidMount() {

     this.getUsers();

}
Editform=event=>{
  reactLocalStorage.set('id_adv',event.target.id);
  window.location="EditAds"
}
Deleteform=event=>{
  event.preventDefault();
  var token=reactLocalStorage.get('accessToken');

  this.setState({ id: event.target.id });
  var id_user= event.target.id;
  
  

  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
 
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/user/rest/advertisments/deleteAdv/"+id_user;   
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/advertisments/deleteAdv/"+id_user;
  }
  var headers = {
   'Content-Type': 'application/json',
    'token' :token
    }
  axios.post(apiBaseUrl,{},{headers: headers}).then(function (response)
  {

  if(response.status === 200)
  {
     
    
  window.location="Adds";


  }
  else if(response.status === 204){
  console.log("Something wrong");

  }
  else{
  console.log("Something wrong");


  }
  })
  .catch(function (error) {
  console.log(error);
  });
}
      render()
      {
          return(
            <div className="big_div">
            <MenuSideWebCMS/>
            <div className="actionMenu">
            <Grid columns={2} divided>
          <Grid.Row stretched>


    <Grid.Column className="grid_logo">
      <Segment>
      <h3 className="text_style mof_color">{i18n.t('View_Advertising.label')}</h3>
      </Segment>
    </Grid.Column>

    <Grid.Column className="grid_language" style={{width:'44%'}}>
      <Segment>
          <Link to="/app/AddAds">
         <img src={require('../pictures/plus_azr2_fate7.png')} className="Logo_auth Logo_auth_adv" alt="logo" />
         </Link>
      </Segment>
    </Grid.Column>

  </Grid.Row>
</Grid>
<hr/>

<div className="container_cards">
{ this.state.persons.map(person =>
  <List divided relaxed>
  <List.Item>
  <List.Content floated='right'>
            <Image avatar className="edit_btn_sub_sender edit_test edit_sub add_btn_snder"  src={require('../pictures/pencil_black.png')}  id={person.id} name={person.sender_id} onClick={this.Editform}/>
            </List.Content>
            <List.Content floated='right' >
            <Image avatar className="delete_btn_sub_sender add_btn_snder" src={require('../pictures/cancel-button_black.png')} id={person.id} onClick={this.Deleteform}/>
    </List.Content>

    
    <List.Content>
      <List.Header as='a' id={person.id} >{i18n.t('Name.label')}  : {person.advertisment_title}</List.Header>
    </List.Content>


  </List.Item>


  <br/>
</List>

)}
</div>
          </div></div>
          );
      }

  }

  const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps) (Adds);